import React, { useState, useEffect, useRef } from 'react';
import ModalComponent from '../modalComponent/ModalComponent';
import SvgComponent from '../svgComponent/SvgComponent';
import departamentos from '../../data/deparments.json';
import './HomeComponent.css';
import { Link } from 'react-router-dom';

const HomeComponent = ({ marketMap, nameDeparment }) => {
  const [accordionOpen, setAccordionOpen] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [makerPosition, setMarketPosition] = useState(null);
  const [imageModal, setImageModal] = useState(null);
  const [titleModal, setTitleModal] = useState(null);
  const [linkVideo, setLinkVideo] = useState(null);
  const [videoPrev, setVidePrev] = useState(null);

  const accordionRefs = useRef([]);

  useEffect(() => {
    if (openModal) {
      document.body.classList.add('modal-open');
    } else {
      document.body.classList.remove('modal-open');
    }
  }, [openModal]);

  useEffect(() => {
    if (nameDeparment) {
      openAccordionByName(nameDeparment);
    }
  }, [nameDeparment]);

  const toggleAccordion = (index, name) => {
    setAccordionOpen((prevIndex) => (prevIndex === index ? null : index));
    setMarketPosition(departamentos.departamentos[index].nombre)
  };

  const openModalHandler = (img, title, link, video) => {
    console.log(img, title, link, video);
    setOpenModal(true);
    setImageModal(img);
    setTitleModal(title);
    setLinkVideo(link);
    setVidePrev(video);
  };

  const closeModalHandler = () => {
    setOpenModal(false);
    setImageModal(null);
    setTitleModal(null);
    setLinkVideo(null);
    setVidePrev(null);
  };

  const openAccordionByName = (departmentName) => {
    const index = departamentos.departamentos.findIndex(dep => dep.nombre === departmentName);
    if (index !== -1 && accordionRefs.current[index]) {
      accordionRefs.current[index].scrollIntoView({ behavior: 'smooth', block: 'center' });
      setAccordionOpen(index);
      setMarketPosition(departmentName);
    }
  };

  return (
    <>
      <div className="container-fluid py-3 mb-3 w-90 rounded" style={{ backgroundColor: '#d7ecff' }}>
        <div className="row">
          {/* Contenido de la primera columna */}
          <div className="col-12 col-md-6 col-lg-6 col-xl-4 mx-auto text-center text-white mt-5">
            <p className='text-justify text-start mx-5 mt-5 mb-5 text-dark text-map d-none d-md-none d-lg-block d-xl-block'>
              Haga <strong>clic en las diferentes</strong> <br />
              <strong>ubicaciones</strong> del mapa para ver <br />
              los <strong>casos clínicos</strong> y la experiencia <br />
              de diferentes especialistas en <br />
              Colombia con el uso de <br />
              <strong>Semaglutida oral.</strong>
            </p>

            <p className='text-justify text-start mx-5 mt-5 mb-5 text-dark d-block d-md-block d-lg-none d-xl-none'>
              Haga <strong>clic en las diferentes</strong> <br />
              <strong>ubicaciones</strong> del mapa para ver <br />
              los <strong>casos clínicos</strong> y la experiencia <br />
              de diferentes especialistas en <br />
              Colombia con el uso de <br />
              <strong>Semaglutida oral.</strong>
            </p>
          </div>

          {/* SVG Component */}
          <div className="col-12 col-md-6 col-lg-5 col-xl-4 text-center text-white mt-1">
            <SvgComponent openAccordionByName={openAccordionByName} markerPosition={makerPosition} />
          </div>

          {/* Contenido de la tercera columna */}
          <div className="col-12 col-md-12 col-lg-12 col-xl-4 text-center text-white mt-5">
            <div className='container'>
              <div className='col-12 col-md-12 col-lg-12 col-xl-12'>
                <p className='text-justify mb-0 text-center fs-5 text-dark-blue'>¡Acompáñenos en nuestro</p>
                <h3 className='text-justify mb-0 text-center fw-bold text-dark-blue'>recorrido por el país!</h3>

                <section className="py-3 scrolling mt-3 mb-5">
                  <div className="container">
                    <div className="w-lg-100 mx-auto">
                      <div className="accordion accordion-flush" id="accordionExample">
                        {departamentos.departamentos.map((dep, index) => (
                          <div
                            key={index}
                            className="accordion-item bg-transparent mb-2"
                            ref={el => accordionRefs.current[index] = el}
                          >
                            <h2 className="accordion-header">
                              {dep.enabled ? (
                                <button
                                  className={`accordion-button accordion-button-dark ${accordionOpen === index ? '' : 'collapsed'} ${accordionOpen === index ? 'bg-actived-home' : 'bg-normal-home'}`}
                                  type="button"
                                  onClick={() => toggleAccordion(index, dep.name)}
                                  aria-expanded={accordionOpen === index ? 'true' : 'false'}
                                  aria-controls={`coll${index}`}
                                  data-bs-toggle="collapse"
                                  data-bs-target={`#coll${index}`}
                                >
                                  <h6 className='p-1 mx-5 fs-6 mt-1 mb-1 text-dark-blue fw-bold'>{dep.nombre}</h6>
                                  <span className={`ms-2 text-dark-blue fw-bold ${accordionOpen === index ? 'rotate' : ''}`}></span>
                                </button>
                              ) : (
                                <button
                                  className={`accordion-button accordion-button-dark-disabled ${accordionOpen === index ? '' : 'collapsed'} ${accordionOpen === index ? 'bg-actived-home' : 'bg-normal-home'}`}
                                  type="button"
                                  onClick={() => toggleAccordion(index, dep.name)}
                                  aria-expanded={accordionOpen === index ? 'true' : 'false'}
                                  aria-controls={`coll${index}`}
                                  data-bs-toggle="collapse"
                                  data-bs-target={`#coll${index}`}
                                  disabled="true"
                                >
                                  <h6 className={`p-1 mx-5 fs-6 mt-1 mb-1 fw-bold ${dep.enabled ? 'text-dark-blue' : 'text-gray-button'}`}>{dep.nombre}</h6>
                                  <span className={`ms-2 text-dark-blue fw-bold ${accordionOpen === index ? 'rotate' : ''}`}></span>
                                </button>
                              )}
                            </h2>
                            <div
                              id={`coll${index}`}
                              className={`accordion-collapse collapse ${accordionOpen === index ? 'show' : ''}`}
                              data-bs-parent="#accordionExample"
                            >
                              <div className="accordion-body d-flex flex-column justify-content-center align-items-center col-12">
                                <div className="row">
                                  <div className="col-12 col-md-5 col-lg-5 col-xl-5">
                                    {dep.data ? (
                                      dep.data.map((dataDep, index) => (
                                        <img
                                          key={index}
                                          src="Thumbnail.png"
                                          alt="Descripción de la imagen"
                                          className="img-fluid pointer"
                                          style={{ maxWidth: '130px' }}
                                          onClick={() => openModalHandler(dataDep.img, dataDep.text, null, dataDep.video)}
                                        />
                                      ))
                                    ) : (
                                      <img
                                        key={index}
                                        src="Thumbnail.png"
                                        alt="Descripción de la imagen"
                                        className="img-fluid pointer"
                                        style={{ maxWidth: '130px' }}
                                        onClick={() => openModalHandler(null, null, null, null)}
                                      />
                                    )}
                                  </div>
                                  <div className="col-12 col-md-7 col-lg-7 col-xl-7">
                                    <p className="text-sm-center text-md-start mb-md-2 font-13 mb-0">
                                      <strong className='text-dark-blue'>Capítulo 1:</strong> Experiencia con <br />
                                      Semaglutida oral en Colombia. <br />
                                      <strong className='text-dark'>Dr. Fredy Andrés Luna</strong> <br />
                                      <Link to="/chapters"><strong className='text-dark-blue'>Ver más</strong></Link>
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div>

        {/* Modal Component */}
        <ModalComponent showModal={openModal} imgPrev={imageModal} titleModal={titleModal} linkVideo={linkVideo} videoModal={videoPrev} closeModal={closeModalHandler} />
      </div>

      <div className='col-12 w-100 d-flex justify-content-center mt-3 mb-3'>
        <Link to="/chapters" style={{ textDecoration: 'none' }}><button className='d-none d-md-block d-lg-block d-xl-block bnt-pc'>Ver todos los capítulos</button></Link>
        <Link to="/chapters" style={{ textDecoration: 'none' }}><button className='d-block d-md-none d-lg-none d-xl-none bnt-mobile'>Ver todos los capítulos</button></Link>
      </div>
    </>
  );
};

export default HomeComponent;
